import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import {Box, Skeleton, Typography} from '@mui/material';

interface BalanceItemProps {
  id: string;
  image: string;
  imageAlt: string;
  title: string;
  subtitle: string;
  onClick?: () => void;
  isLoading?: boolean;
}

export const BalanceItem = ({
  id,
  image,
  imageAlt,
  title,
  subtitle,
  onClick,
  isLoading = false,
}: BalanceItemProps) => {
  return (
    <Box
      data-testid={`balance-item-${id}`}
      className="groups-dashboard-balances-participant"
      onClick={!isLoading ? onClick : undefined}>
      <Box className="groups-dashboard-balances-participant-left-icon">
        {isLoading ? (
          <Skeleton
            variant="circular"
            width={40}
            height={40}
          />
        ) : (
          <Box
            component="img"
            src={image}
            alt={imageAlt}
            className="groups-dashboard-balances-participant-left-icon-image"
          />
        )}
      </Box>

      <Box className="groups-dashboard-balances-participant-text">
        {isLoading ? (
          <>
            <Skeleton
              variant="text"
              width="60%"
              height={24}
            />
            <Skeleton
              variant="text"
              width="80%"
              height={20}
            />
          </>
        ) : (
          <>
            <Typography className="groups-dashboard-balances-participant-title">
              {title}
            </Typography>
            <Typography className="groups-dashboard-balances-participant-subtitle">
              {subtitle}
            </Typography>
          </>
        )}
      </Box>

      <Box className="groups-dashboard-balances-participant-right-icon">
        {isLoading ? (
          <Skeleton
            variant="circular"
            width={24}
            height={24}
          />
        ) : (
          <ChevronRightIcon />
        )}
      </Box>
    </Box>
  );
};
